import { render, staticRenderFns } from "./LoadingForm.vue?vue&type=template&id=5fe81d22&"
var script = {}
import style0 from "./LoadingForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports